import axios from "axios";

import {
    ADMIN_addres, API_ADMIN_create_student, API_ADMIN_get_student, API_ADMIN_update_student, API_ADMIN_delete_student, API_ADMIN_get_all_students,
    API_ADMIN_create_course, API_ADMIN_get_course, API_ADMIN_update_course, API_ADMIN_delete_course, API_ADMIN_get_all_courses,
    API_ADMIN_create_event, API_ADMIN_get_event, API_ADMIN_update_event, API_ADMIN_delete_event, API_ADMIN_get_all_events,
    API_ADMIN_create_pay, API_ADMIN_get_pay, API_ADMIN_update_pay, API_ADMIN_delete_pay, API_ADMIN_get_all_pays,
    API_ADMIN_get_account_students, API_ADMIN_create_account_student, API_ADMIN_update_account_student_owner,
    API_ADMIN_update_account_student_teacher, API_ADMIN_get_account_student_owner, API_ADMIN_get_account_student_teacher,
    API_ADMIN_get_prepod_admin, API_ADMIN_create_prepod_admin, API_ADMIN_update_prepod_admin, API_ADMIN_delete_prepod_admin, API_ADMIN_get_single_prepod_admin, API_ADMIN_search_prepod_admin, API_ADMIN_get_prepod_admin_stats,
    API_ADMIN_getCentersCount, API_ADMIN_getStudentsCount, API_ADMIN_getProjectsCount, API_ADMIN_getDashboardStats, API_ADMIN_getAllAccountStudents,
    API_ADMIN_robotehnick_aggregate,
} from './API';
import logger from '../utils/logger';
export default class AdminService {

    // ===== STUDENTS METHODS =====

    // Создать нового студента
    static async createStudent(studentData) {
        try {
            const response = await axios.post(API_ADMIN_create_student, studentData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания студента:', error);
            throw error;
        }
    }

    // Получить студента по ID
    static async getStudent(studentId) {
        try {
            const response = await axios.get(API_ADMIN_get_student + studentId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения студента:', error);
            throw error;
        }
    }

    // Редактировать студента
    static async updateStudent(studentId, studentData) {
        try {
            const response = await axios.put(API_ADMIN_update_student + studentId, studentData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления студента:', error);
            throw error;
        }
    }

    // Удалить студента
    static async deleteStudent(studentId) {
        try {
            const response = await axios.delete(API_ADMIN_delete_student + studentId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления студента:', error);
            throw error;
        }
    }

    // Получить всех студентов
    static async getAllStudents() {
        try {
            const response = await axios.get(API_ADMIN_get_all_students, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка студентов:', error);
            throw error;
        }
    }

    // ===== COURSES METHODS =====

    // Создать новый курс
    static async createCourse(courseData) {
        try {
            const response = await axios.post(API_ADMIN_create_course, courseData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания курса:', error);
            throw error;
        }
    }

    // Получить курс по ID
    static async getCourse(courseId) {
        try {
            const response = await axios.get(API_ADMIN_get_course + courseId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения курса:', error);
            throw error;
        }
    }

    // Редактировать курс
    static async updateCourse(courseId, courseData) {
        try {
            const response = await axios.put(API_ADMIN_update_course + courseId, courseData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления курса:', error);
            throw error;
        }
    }

    // Удалить курс
    static async deleteCourse(courseId) {
        try {
            const response = await axios.delete(API_ADMIN_delete_course + courseId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления курса:', error);
            throw error;
        }
    }

    // Получить все курсы
    static async getAllCourses() {
        try {
            const response = await axios.get(API_ADMIN_get_all_courses, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка курсов:', error);
            throw error;
        }
    }

    // ===== EVENTS METHODS =====

    // Создать новое мероприятие
    static async createEvent(eventData) {
        try {
            const response = await axios.post(API_ADMIN_create_event, eventData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания мероприятия:', error);
            throw error;
        }
    }

    // Получить мероприятие по ID
    static async getEvent(eventId) {
        try {
            const response = await axios.get(API_ADMIN_get_event + eventId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения мероприятия:', error);
            throw error;
        }
    }

    // Редактировать мероприятие
    static async updateEvent(eventId, eventData) {
        try {
            const response = await axios.put(API_ADMIN_update_event + eventId, eventData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления мероприятия:', error);
            throw error;
        }
    }

    // Удалить мероприятие
    static async deleteEvent(eventId) {
        try {
            const response = await axios.delete(API_ADMIN_delete_event + eventId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления мероприятия:', error);
            throw error;
        }
    }

    // Получить все мероприятия
    static async getAllEvents() {
        try {
            const response = await axios.get(API_ADMIN_get_all_events, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка мероприятий:', error);
            throw error;
        }
    }

    // ===== PAYS METHODS =====

    // Создать новый платеж
    static async createPay(payData) {
        try {
            const response = await axios.post(API_ADMIN_create_pay, payData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания платежа:', error);
            throw error;
        }
    }

    // Получить платеж по ID
    static async getPay(payId) {
        try {
            const response = await axios.get(API_ADMIN_get_pay + payId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения платежа:', error);
            throw error;
        }
    }

    // Редактировать платеж
    static async updatePay(payId, payData) {
        try {
            const response = await axios.put(API_ADMIN_update_pay + payId, payData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления платежа:', error);
            throw error;
        }
    }

    // Удалить платеж
    static async deletePay(payId) {
        try {
            const response = await axios.delete(API_ADMIN_delete_pay + payId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления платежа:', error);
            throw error;
        }
    }

    // Получить все платежи
    static async getAllPays() {
        try {
            const response = await axios.get(API_ADMIN_get_all_pays, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка платежей:', error);
            throw error;
        }
    }

    // ===== HELPER METHODS =====

    // Универсальный метод для обработки ошибок с детализацией
    static handleError(error, operation) {
        if (error.response) {
            // Сервер ответил с кодом ошибки
            const { status, data } = error.response;
            logger.error(`Ошибка ${operation}:`, { status, message: data.message || data });

            if (status === 401) {
                // Токен недействителен или отсутствует
                localStorage.removeItem('Authorization');
                window.location.href = '/login';
                return { error: 'Необходима авторизация' };
            }

            return {
                error: data.message || `Ошибка сервера: ${status}`,
                status
            };
        } else if (error.request) {
            // Запрос был отправлен, но ответа не получено
            logger.error(`Ошибка сети при ${operation}:`, error.request);
            return { error: 'Ошибка сети. Проверьте подключение к интернету.' };
        } else {
            // Ошибка при настройке запроса
            logger.error(`Ошибка запроса ${operation}:`, error.message);
            return { error: 'Неизвестная ошибка запроса.' };
        }
    }

    // Проверка авторизации
    static isAuthenticated() {
        return !!localStorage.getItem('Authorization');
    }

    // Получить заголовки по умолчанию
    static getDefaultHeaders() {
        return {
            'Authorization': localStorage.getItem('Authorization'),
            'Content-Type': 'application/json'
        };
    }

    // ===== ACCOUNT STUDENTS METHODS =====

    // Получить все AccountStudents владельца
    static async getAllAccountStudents() {
        try {
            const response = await axios.get(API_ADMIN_get_account_students, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка AccountStudents:', error);
            throw error;
        }
    }

    // Агрегатный эндпоинт «всё для страниц РобоТехники».
    // Один HTTP-запрос вместо трёх. Возвращает:
    //   { success, data: { accounts: [...], students: {id: {...}}, minecraftia: {id: {...}} } }
    // filter: 'approved' | 'pending' | 'all' (по умолчанию 'all').
    //
    // approvedTasks / pendingTasks в каждом аккаунте уже распарсены на бэке
    // (фронту не нужно JSON.parse 100 раз).
    static async getRobotehnickAggregate(filter = 'all') {
        try {
            const response = await axios.get(API_ADMIN_robotehnick_aggregate, {
                params: { filter },
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения агрегата РобоТехники:', error);
            throw error;
        }
    }

    // Создать новую запись AccountStudents
    static async createAccountStudent(accountData) {
        try {
            const response = await axios.post(API_ADMIN_create_account_student, accountData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания AccountStudent:', error);
            throw error;
        }
    }

    // Редактировать AccountStudents (владелец)
    static async updateAccountStudentOwner(accountId, accountData) {
        try {
            const response = await axios.put(API_ADMIN_update_account_student_owner + accountId, accountData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления AccountStudent (владелец):', error);
            throw error;
        }
    }

    // Редактировать задания AccountStudents (преподаватель)
    static async updateAccountStudentTeacher(accountId, taskData) {
        try {
            const response = await axios.put(API_ADMIN_update_account_student_teacher + accountId + '/teacher', taskData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления заданий AccountStudent (преподаватель):', error);
            throw error;
        }
    }

    // Получить одну запись AccountStudents (владелец)
    static async getAccountStudentOwner(accountId) {
        try {
            const response = await axios.get(API_ADMIN_get_account_student_owner + accountId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения AccountStudent (владелец):', error);
            throw error;
        }
    }

    // Получить запись AccountStudents (преподаватель, ограниченные данные)
    static async getAccountStudentTeacher(accountId) {
        try {
            const response = await axios.get(API_ADMIN_get_account_student_teacher + accountId + '/teacher', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения AccountStudent (преподаватель):', error);
            throw error;
        }
    }

    // Удалить запись AccountStudents
    static async deleteAccountStudent(accountId) {
        try {
            const response = await axios.delete(API_ADMIN_update_account_student_owner + accountId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления привязки аккаунта:', error);
            throw error;
        }
    }

    // ===== MY PREPOD AND ADMIN METHODS =====

    // Получить все записи преподов и админов
    static async getAllPrepodAdmin() {
        try {
            const response = await axios.get(API_ADMIN_get_prepod_admin, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка преподов/админов:', error);
            throw error;
        }
    }

    // Создать запись преподавателя/администратора
    static async createPrepodAdmin(prepodData) {
        try {
            // Валидируем данные перед отправкой
            if (!prepodData.UserId || !prepodData.status) {
                throw new Error('Поля UserId и status обязательны');
            }

            const response = await axios.post(API_ADMIN_create_prepod_admin, {
                UserId: prepodData.UserId,
                status: prepodData.status,
                ferstName: prepodData.ferstName || '',
                lastName: prepodData.lastName || '',
                phone: prepodData.phone || '',
                telegram: prepodData.telegram || ''
            }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания преподавателя/администратора:', error);
            throw error;
        }
    }

    // Получить конкретного преподавателя/администратора
    static async getSinglePrepodAdmin(prepodId) {
        try {
            const response = await axios.get(API_ADMIN_get_single_prepod_admin + prepodId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения преподавателя/администратора:', error);
            throw error;
        }
    }

    // Редактировать преподавателя/администратора
    static async updatePrepodAdmin(prepodId, prepodData) {
        try {
            const response = await axios.put(API_ADMIN_update_prepod_admin + prepodId, prepodData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления преподавателя/администратора:', error);
            throw error;
        }
    }

    // Удалить преподавателя/администратора
    static async deletePrepodAdmin(prepodId) {
        try {
            const response = await axios.delete(API_ADMIN_delete_prepod_admin + prepodId, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления преподавателя/администратора:', error);
            throw error;
        }
    }

    // Поиск преподавателей/администраторов
    static async searchPrepodAdmin(searchQuery, statusFilter = '') {
        try {
            const params = new URLSearchParams();
            if (searchQuery) {
                params.append('q', searchQuery);
            }
            if (statusFilter) {
                params.append('status', statusFilter);
            }

            const response = await axios.get(`${API_ADMIN_search_prepod_admin}?${params.toString()}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка поиска преподавателей/администраторов:', error);
            throw error;
        }
    }

    // Получить статистику преподавателей/администраторов
    static async getPrepodAdminStats() {
        try {
            const response = await axios.get(API_ADMIN_get_prepod_admin_stats, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статистики преподов/админов:', error);
            throw error;
        }
    }

    // ===== HELPER METHODS ДЛЯ НОВЫХ ТАБЛИЦ =====

    // Проверить связку AccountStudent по idStudent
    static async getAccountStudentByStudentId(studentId) {
        try {
            const allAccounts = await this.getAllAccountStudents();
            if (allAccounts.success) {
                const account = allAccounts.data.find(acc => acc.idStudent === studentId);
                return account ? { success: true, data: account } : { success: false, data: null };
            }
            return { success: false, data: null };
        } catch (error) {
            logger.error('Ошибка поиска AccountStudent по idStudent:', error);
            throw error;
        }
    }

    // Получить активные AccountStudents
    static async getActiveAccountStudents() {
        try {
            const allAccounts = await this.getAllAccountStudents();
            if (allAccounts.success) {
                const activeAccounts = allAccounts.data.filter(acc => acc.status === 'активен');
                return { success: true, data: activeAccounts };
            }
            return { success: false, data: [] };
        } catch (error) {
            logger.error('Ошибка получения активных AccountStudents:', error);
            throw error;
        }
    }

    // Получить AccountStudents с заданиями на проверке
    static async getAccountStudentsWithPendingTasks() {
        try {
            const allAccounts = await this.getAllAccountStudents();
            if (allAccounts.success) {
                const accountsWithTasks = allAccounts.data.filter(acc => {
                    try {
                        const pendingTasks = JSON.parse(acc.taskRobotehnikProwerka || '[]');
                        return pendingTasks.length > 0;
                    } catch (e) {
                        return false;
                    }
                });
                return { success: true, data: accountsWithTasks };
            }
            return { success: false, data: [] };
        } catch (error) {
            logger.error('Ошибка получения AccountStudents с заданиями на проверке:', error);
            throw error;
        }
    }

    // Получить доступы по статусу
    static async getPrepodAdminByStatus(status) {
        try {
            const allAccess = await this.getAllPrepodAdmin();
            if (allAccess.success) {
                const filteredAccess = allAccess.data.filter(access => access.status === status);
                return { success: true, data: filteredAccess };
            }
            return { success: false, data: [] };
        } catch (error) {
            logger.error(`Ошибка получения доступов со статусом ${status}:`, error);
            throw error;
        }
    }

    // Проверить, есть ли доступ у пользователя
    static async checkUserAccess(userId, requiredStatus) {
        try {
            const allAccess = await this.getAllPrepodAdmin();
            if (allAccess.success) {
                const userAccess = allAccess.data.find(access =>
                    access.UserId === userId && access.status === requiredStatus
                );
                return { success: true, hasAccess: !!userAccess, data: userAccess };
            }
            return { success: false, hasAccess: false, data: null };
        } catch (error) {
            logger.error('Ошибка проверки доступа пользователя:', error);
            throw error;
        }
    }

    // Валидация данных преподавателя/администратора
    static validatePrepodAdminData(data) {
        const errors = [];

        if (!data.UserId) {
            errors.push('ID пользователя обязателен');
        }

        if (!data.status) {
            errors.push('Статус обязателен');
        }

        if (data.status && !['read', 'update', 'prepod'].includes(data.status)) {
            errors.push('Статус должен быть: read, update или prepod');
        }

        if (data.phone && data.phone.trim()) {
            const phoneClean = data.phone.replace(/[\s\-\(\)]/g, '');
            if (!/^\+?\d{10,15}$/.test(phoneClean)) {
                errors.push('Некорректный формат номера телефона');
            }
        }

        if (data.telegram && data.telegram.trim()) {
            const telegram = data.telegram.trim();
            if (!telegram.startsWith('@') &&
                !telegram.startsWith('https://t.me/') &&
                !telegram.startsWith('http://t.me/')) {
                errors.push('Ссылка на телеграм должна начинаться с @ или содержать t.me');
            }
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }

    // Получить полную информацию о преподавателе/администраторе включая данные из Майнкрафтии
    static async getPrepodAdminWithMinecraftData(prepodId) {
        try {
            const prepodData = await this.getSinglePrepodAdmin(prepodId);
            if (prepodData.success) {
                // Получаем данные из Майнкрафтии, если есть UserId
                if (prepodData.data.UserId) {
                    try {
                        // Здесь должен быть вызов к API майнкрафтии для получения данных пользователя
                        // Пока возвращаем базовую информацию
                        prepodData.data.minecraftData = {
                            userId: prepodData.data.UserId,
                            // Дополнительные поля будут добавлены при подключении к API майнкрафтии
                        };
                    } catch (minecraftError) {
                        logger.warn('Не удалось получить данные из Майнкрафтии:', minecraftError);
                        prepodData.data.minecraftData = null;
                    }
                }
                return prepodData;
            }
            return prepodData;
        } catch (error) {
            logger.error('Ошибка получения расширенных данных преподавателя/администратора:', error);
            throw error;
        }
    }

    static async approveProject(accountId, projectId, filename) {
        try {
            logger.log('🔄 Отправляем запрос на принятие проекта...');

            const response = await axios.put(
                `${ADMIN_addres}/api/v1/account_students/${accountId}/approve_project`,
                {
                    projectId: projectId,
                    filename: filename
                },
                {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization'),
                        'Content-Type': 'application/json'
                    },
                    timeout: 10000 // 10 секунд timeout
                }
            );

            logger.log('✅ Ответ сервера:', response.data);
            return response.data;

        } catch (error) {
            logger.error('❌ Ошибка принятия проекта:', error);

            // Более детальная обработка ошибок
            if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
                throw new Error('Ошибка сети. Проверьте подключение и попробуйте снова.');
            }

            if (error.response) {
                const status = error.response.status;
                const message = error.response.data?.message || 'Неизвестная ошибка';

                if (status === 404) {
                    throw new Error('Endpoint не найден. Обратитесь к разработчику.');
                } else if (status === 500) {
                    throw new Error('Внутренняя ошибка сервера: ' + message);
                } else if (status === 403) {
                    throw new Error('Нет прав доступа: ' + message);
                } else {
                    throw new Error(`Ошибка ${status}: ${message}`);
                }
            }

            throw error;
        }
    }

    static async rejectProject(accountId, projectId, filename) {
        try {
            logger.log('🔄 Отправляем запрос на отклонение проекта...');

            const response = await axios.put(
                `${ADMIN_addres}/api/v1/account_students/${accountId}/reject_project`,
                {
                    projectId: projectId,
                    filename: filename
                },
                {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization'),
                        'Content-Type': 'application/json'
                    },
                    timeout: 10000
                }
            );

            logger.log('✅ Ответ сервера:', response.data);
            return response.data;

        } catch (error) {
            logger.error('❌ Ошибка отклонения проекта:', error);

            if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
                throw new Error('Ошибка сети. Проверьте подключение и попробуйте снова.');
            }

            if (error.response) {
                const status = error.response.status;
                const message = error.response.data?.message || 'Неизвестная ошибка';
                throw new Error(`Ошибка ${status}: ${message}`);
            }

            throw error;
        }
    }

    // Получить количество детских центров
    static async getCentersCount() {
        try {
            const response = await axios.get(API_ADMIN_getCentersCount, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения количества центров:', error);
            throw error;
        }
    }

    // Получить количество студентов
    static async getStudentsCount() {
        try {
            const response = await axios.get(API_ADMIN_getStudentsCount, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения количества студентов:', error);
            throw error;
        }
    }

    // Получить количество выполненных проектов
    static async getProjectsCount() {
        try {
            const response = await axios.get(API_ADMIN_getProjectsCount, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения количества проектов:', error);
            throw error;
        }
    }

    // Агрегатная статистика для /main/materials — один запрос вместо четырёх.
    // Возвращает { success, data: { centers, students, projects, minecraftTasks } }.
    // students здесь = число зарегистрированных пользователей в user-сервисе,
    // minecraftTasks = суммарное количество решённых заданий Майнкрафтии.
    static async getDashboardStats() {
        try {
            const response = await axios.get(API_ADMIN_getDashboardStats, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения дашборд-статистики:', error);
            throw error;
        }
    }

    // Получить все AccountStudents (для Materials)
    static async getAllAccountStudentsForStats() {
        try {
            const response = await axios.get(API_ADMIN_getAllAccountStudents, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения списка AccountStudents для статистики:', error);
            throw error;
        }
    }


    // ===== FORUM METHODS =====

    // Получить все категории форума
    static async getForumCategories() {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/categories`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения категорий форума:', error);
            throw error;
        }
    }

    // Получить темы конкретной категории
    static async getCategoryTopics(categoryId, page = 1, perPage = 20) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/categories/${categoryId}/topics`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    page: page,
                    per_page: perPage
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения тем категории:', error);
            throw error;
        }
    }

    // Создать новую тему
    static async createForumTopic(topicData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/forum/topics`, topicData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания темы:', error);
            throw error;
        }
    }

    // Получить конкретную тему с комментариями
    static async getForumTopic(topicId, page = 1, perPage = 50) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/topics/${topicId}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    page: page,
                    per_page: perPage
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения темы:', error);
            throw error;
        }
    }

    // Создать комментарий к теме
    static async createForumComment(topicId, commentData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/forum/topics/${topicId}/comments`, commentData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания комментария:', error);
            throw error;
        }
    }

    // Изменить статус темы (открыть/закрыть)
    static async updateTopicStatus(topicId, status) {
        try {
            const response = await axios.put(`${ADMIN_addres}/api/v1/forum/topics/${topicId}/status`,
                { status },
                {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization'),
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления статуса темы:', error);
            throw error;
        }
    }

    // Получить статистику форума
    static async getForumStats() {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/stats`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статистики форума:', error);
            throw error;
        }
    }

    // Поиск по форуму
    static async searchForum(query) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/search`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    q: query
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка поиска по форуму:', error);
            throw error;
        }
    }

    // ===== HELPER METHODS ДЛЯ ФОРУМА =====

    // Валидация данных темы
    static validateTopicData(data) {
        const errors = [];

        if (!data.title || data.title.trim().length < 5) {
            errors.push('Заголовок темы должен содержать минимум 5 символов');
        }

        if (!data.content || data.content.trim().length < 10) {
            errors.push('Содержание темы должно содержать минимум 10 символов');
        }

        if (!data.category_id) {
            errors.push('Выберите категорию для темы');
        }

        return errors;
    }

    // Валидация данных комментария
    static validateCommentData(data) {
        const errors = [];

        if (!data.content || data.content.trim().length < 1) {
            errors.push('Комментарий не может быть пустым');
        }

        if (data.content && data.content.length > 5000) {
            errors.push('Комментарий слишком длинный (максимум 5000 символов)');
        }

        return errors;
    }

    // Форматирование даты для отображения
    static formatForumDate(dateString) {
        if (!dateString) return 'Никогда';

        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
            return 'Сегодня в ' + date.toLocaleTimeString('ru-RU', {
                hour: '2-digit',
                minute: '2-digit'
            });
        } else if (diffDays === 1) {
            return 'Вчера в ' + date.toLocaleTimeString('ru-RU', {
                hour: '2-digit',
                minute: '2-digit'
            });
        } else if (diffDays < 7) {
            return `${diffDays} дня назад`;
        } else {
            return date.toLocaleDateString('ru-RU') + ' в ' +
                date.toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit'
                });
        }
    }

    // Форматирование даты
    static formatDate(dateString) {
        if (!dateString) return 'Не указано';

        const date = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };

        return date.toLocaleDateString('ru-RU', options);
    }

    // Обрезка текста для превью
    static truncateText(text, maxLength = 100) {
        if (!text) return '';

        if (text.length <= maxLength) {
            return text;
        }

        return text.substring(0, maxLength).trim() + '...';
    }

    // Обновить тему
    static async updateForumTopic(topicId, topicData) {
        try {
            const response = await axios.put(`${ADMIN_addres}/api/v1/forum/topics/${topicId}`, topicData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления темы:', error);
            throw error;
        }
    }

    // Получить мои темы
    static async getMyForumTopics(page = 1, perPage = 20) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/topics/my`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    page: page,
                    per_page: perPage
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения моих тем:', error);
            throw error;
        }
    }

    // Получить информацию о категории
    static async getForumCategory(categoryId) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/forum/categories`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });

            const categories = response.data.data || [];
            return categories.find(cat => cat.id == categoryId) || { name: 'Неизвестная категория' };
        } catch (error) {
            logger.error('Ошибка получения категории:', error);
            return { name: 'Неизвестная категория' };
        }
    }

    // Получить текущего пользователя из JWT токена
    static getCurrentUserId() {
        try {
            const token = localStorage.getItem('Authorization');
            if (!token) return null;

            // Декодируем JWT токен (без библиотеки jwt-decode)
            const payload = token.split('.')[1];
            const decoded = JSON.parse(atob(payload));
            return decoded.id || decoded.user_id || decoded.sub;
        } catch (error) {
            logger.error('Ошибка получения ID пользователя:', error);
            return null;
        }
    }

    // Получить список статей
    static async getArticles(page = 1, perPage = 20, sortBy = 'recent', searchQuery = '', tagFilter = '', authorId = null) {
        try {
            const params = {
                page,
                per_page: perPage,
                sort_by: sortBy,
            };

            if (searchQuery) params.search = searchQuery;
            if (tagFilter) params.tag = tagFilter;
            if (authorId) params.author_id = authorId;

            const response = await axios.get(`${ADMIN_addres}/api/v1/articles`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статей:', error);
            throw error;
        }
    }

    // Получить конкретную статью
    static async getArticle(articleId) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/articles/${articleId}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статьи:', error);
            throw error;
        }
    }

    // Создать новую статью
    static async createArticle(articleData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/articles`, articleData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания статьи:', error);
            throw error;
        }
    }

    // Обновить статью
    static async updateArticle(articleId, articleData) {
        try {
            const response = await axios.put(`${ADMIN_addres}/api/v1/articles/${articleId}`, articleData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления статьи:', error);
            throw error;
        }
    }

    // Удалить статью
    static async deleteArticle(articleId) {
        try {
            const response = await axios.delete(`${ADMIN_addres}/api/v1/articles/${articleId}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления статьи:', error);
            throw error;
        }
    }

    // Получить мои статьи
    static async getMyArticles(page = 1, perPage = 20) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/articles/my`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    page,
                    per_page: perPage
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения моих статей:', error);
            throw error;
        }
    }

    // Добавить комментарий к статье
    static async createArticleComment(articleId, commentData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/articles/${articleId}/comments`, commentData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка добавления комментария:', error);
            throw error;
        }
    }

    // Оценить статью
    static async rateArticle(articleId, rating) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/articles/${articleId}/rating`,
                { rating }, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка оценки статьи:', error);
            throw error;
        }
    }

    // Загрузить изображение для статьи
    static async uploadArticleImage(imageFile) {
        try {
            const formData = new FormData();
            formData.append('file', imageFile);

            const response = await axios.post(`${ADMIN_addres}/api/v1/articles/upload-image`, formData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка загрузки изображения:', error);
            throw error;
        }
    }

    // Получить статистику статей
    static async getArticlesStats() {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/articles/stats`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статистики статей:', error);
            throw error;
        }
    }

    // Получить статистику моих статей
    static async getMyArticlesStats() {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/articles/my-stats`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения моей статистики:', error);
            throw error;
        }
    }

    // Получить популярные теги
    static async getPopularTags(limit = 20) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/articles/tags`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: { limit }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения тегов:', error);
            throw error;
        }
    }

    // ============ ВСПОМОГАТЕЛЬНЫЕ МЕТОДЫ ============

    // Валидация данных статьи
    static validateArticleData(articleData) {
        const errors = [];

        if (!articleData.title || articleData.title.trim().length < 3) {
            errors.push('Заголовок статьи должен содержать минимум 3 символа');
        }

        if (articleData.title && articleData.title.length > 200) {
            errors.push('Заголовок статьи не должен превышать 200 символов');
        }

        if (!articleData.content || articleData.content.trim().length < 50) {
            errors.push('Содержание статьи должно содержать минимум 50 символов');
        }

        if (articleData.summary && articleData.summary.length > 500) {
            errors.push('Описание статьи не должно превышать 500 символов');
        }

        if (articleData.difficulty_level && (articleData.difficulty_level < 1 || articleData.difficulty_level > 5)) {
            errors.push('Уровень сложности должен быть от 1 до 5');
        }

        if (articleData.tags && articleData.tags.length > 10) {
            errors.push('Максимальное количество тегов - 10');
        }

        return errors;
    }

    // Валидация комментария
    static validateCommentData(commentData) {
        const errors = [];

        if (!commentData.content || commentData.content.trim().length < 3) {
            errors.push('Комментарий должен содержать минимум 3 символа');
        }

        if (commentData.content && commentData.content.length > 2000) {
            errors.push('Комментарий не должен превышать 2000 символов');
        }

        return errors;
    }

    // Форматирование времени чтения
    static formatReadTime(minutes) {
        if (minutes === 1) {
            return '1 минута чтения';
        } else if (minutes < 5) {
            return `${minutes} минуты чтения`;
        } else {
            return `${minutes} минут чтения`;
        }
    }

    // Форматирование рейтинга
    static formatRating(rating) {
        if (!rating) return '0.0';
        return parseFloat(rating).toFixed(1);
    }

    // Обрезка текста для превью
    static truncateText(text, maxLength = 150) {
        if (!text) return '';
        if (text.length <= maxLength) return text;

        // Удаляем HTML теги для превью
        const cleanText = text.replace(/<[^>]*>/g, '');

        if (cleanText.length <= maxLength) return cleanText;

        const truncated = cleanText.substring(0, maxLength);
        const lastSpace = truncated.lastIndexOf(' ');

        return lastSpace > 0
            ? truncated.substring(0, lastSpace) + '...'
            : truncated + '...';
    }

    // Извлечение первого изображения из контента статьи
    static extractFirstImage(content) {
        const imgRegex = /<img[^>]+src="([^">]+)"/;
        const match = content.match(imgRegex);
        return match ? match[1] : null;
    }

    // Форматирование тегов
    static formatTags(tags) {
        if (!tags || !Array.isArray(tags)) return [];
        return tags.map(tag => typeof tag === 'string' ? tag.trim().toLowerCase() : tag.name);
    }

    // Получение уровня сложности в текстовом виде
    static getDifficultyText(level) {
        const levels = {
            1: 'Начинающий',
            2: 'Легкий',
            3: 'Средний',
            4: 'Продвинутый',
            5: 'Экспертный'
        };
        return levels[level] || 'Не указан';
    }

    // Форматирование больших чисел
    static formatLargeNumber(number) {
        if (!number) return '0';
        if (number >= 1000000) {
            return (number / 1000000).toFixed(1) + 'М';
        } else if (number >= 1000) {
            return (number / 1000).toFixed(1) + 'К';
        }
        return number.toString();
    }

    // ============ FAQ МЕТОДЫ ============

    // Получить категории FAQ
    static async getFAQCategories() {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/faq/categories`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения категорий FAQ:', error);
            throw error;
        }
    }

    // Получить статьи FAQ
    static async getFAQArticles(categoryName = '', searchQuery = '', page = 1, perPage = 20) {
        try {
            const params = {
                page,
                per_page: perPage,
            };

            if (categoryName) params.category = categoryName;
            if (searchQuery) params.search = searchQuery;

            const response = await axios.get(`${ADMIN_addres}/api/v1/faq/articles`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статей FAQ:', error);
            throw error;
        }
    }

    // Получить конкретную статью FAQ
    static async getFAQArticle(articleId) {
        try {
            const response = await axios.get(`${ADMIN_addres}/api/v1/faq/articles/${articleId}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения статьи FAQ:', error);
            throw error;
        }
    }

    // Создать новую статью FAQ
    static async createFAQArticle(articleData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/faq/articles`, articleData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка создания статьи FAQ:', error);
            throw error;
        }
    }

    // Обновить статью FAQ
    static async updateFAQArticle(articleId, articleData) {
        try {
            const response = await axios.put(`${ADMIN_addres}/api/v1/faq/articles/${articleId}`, articleData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка обновления статьи FAQ:', error);
            throw error;
        }
    }

    // Удалить статью FAQ
    static async deleteFAQArticle(articleId) {
        try {
            const response = await axios.delete(`${ADMIN_addres}/api/v1/faq/articles/${articleId}`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка удаления статьи FAQ:', error);
            throw error;
        }
    }

    // Добавить комментарий к статье FAQ
    static async createFAQComment(articleId, commentData) {
        try {
            const response = await axios.post(`${ADMIN_addres}/api/v1/faq/articles/${articleId}/comments`, commentData, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка добавления комментария FAQ:', error);
            throw error;
        }
    }

    // Получить подсказки для поиска FAQ
    static async getFAQSearchSuggestions(query, categoryName = '') {
        try {
            const params = { q: query };
            if (categoryName) params.category = categoryName;

            const response = await axios.get(`${ADMIN_addres}/api/v1/faq/search-suggestions`, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params
            });
            return response.data;
        } catch (error) {
            logger.error('Ошибка получения подсказок FAQ:', error);
            throw error;
        }
    }

    // Валидация данных статьи FAQ
    static validateFAQArticleData(articleData) {
        const errors = [];

        if (!articleData.title || articleData.title.trim().length < 3) {
            errors.push('Заголовок статьи должен содержать минимум 3 символа');
        }

        if (articleData.title && articleData.title.length > 300) {
            errors.push('Заголовок статьи не должен превышать 300 символов');
        }

        if (!articleData.content || articleData.content.trim().length < 10) {
            errors.push('Содержание статьи должно содержать минимум 10 символов');
        }

        if (articleData.summary && articleData.summary.length > 1000) {
            errors.push('Описание статьи не должно превышать 1000 символов');
        }

        if (!articleData.category_id) {
            errors.push('Необходимо выбрать категорию');
        }

        return errors;
    }

    // Валидация комментария FAQ
    static validateFAQCommentData(commentData) {
        const errors = [];

        if (!commentData.content || commentData.content.trim().length < 3) {
            errors.push('Комментарий должен содержать минимум 3 символа');
        }

        if (commentData.content && commentData.content.length > 2000) {
            errors.push('Комментарий не должен превышать 2000 символов');
}

        return errors;
    }








}